module.exports = __webpack_public_path__ + "media/img/home/directions/list-8-9c946c5a9b7d7ea5ff53b27a0e961fe8.svg";